import { render, staticRenderFns } from "./RequestReferencesDialog.vue?vue&type=template&id=46523dc1&"
import script from "./RequestReferencesDialog.vue?vue&type=script&lang=js&"
export * from "./RequestReferencesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports